var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_button",
    "data-name": "send button",
    transform: "translate(-1241 -698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    d: "M0,0H75a5,5,0,0,1,5,5V45a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1241 698)",
    fill: "#65a844"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-send",
    transform: "translate(1251.699 -11.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M98.216,40.766c.647.462-4.344,22.029-4.683,22.245-.185.123-1.972-.986-6.07-4.036-1.571-1.171-.986-1.14-4.776,2.588-.74.709-.74.709-1.2-.585L79.514,55.8c-.493-1.294-.493-1.294-1.694-1.91-3.635-1.849-5.546-2.711-5.546-3.019,0-.74,25.2-10.629,25.942-10.106ZM81.794,57.588c-.308-.709-.924-2.526-1.2-3.42-.308-.924-.308-.924,1.941-2.434,13.926-9.335,14.019-10.167,1.91,1.448-2.372,2.28-1.818,1.479-2.157,4.1-.062.4-.123.709-.216.678q-.093,0-.277-.37Z",
    transform: "translate(-55.974 683)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send_button.885e8f2f14ca49194a7292041a85dc1b.svg";
export { ForwardRef as ReactComponent };